import React from 'react';
import './WhatsAppButton.css';
import { useInitialFetch } from 'core/context/initialFetchContext';

const WhatsAppButton = () => {
    const { storeInformation } = useInitialFetch();

    const handleClick = () => {
        const message = "Hola, quisiera más información acerca de sus servicios.";
        const url = `https://wa.me/${storeInformation.whatsapp}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    return (
        <button
            className="whatsapp-button"
            onClick={handleClick}
            aria-label="Chat with us on WhatsApp"
        >
            <i className="fa-brands fa-whatsapp" style={{ "fontSize": "42px", "marginBottom": "4px" }}></i>
        </button>
    );
}

export default WhatsAppButton;
